
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cCE4B", function(module, exports) {
/* RecentlyUpdatedMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");




const $50e0564811ea6833$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    heading: {
        id: "recently-updated-macro.heading",
        defaultMessage: "Recent updates"
    },
    noUpdates: {
        id: "recently-updated-macro.no-updates",
        defaultMessage: "No updates yet."
    },
    showMore: {
        id: "recently-updated-macro.show-more",
        defaultMessage: "Show more"
    },
    showMoreAriaLabel: {
        id: "recently-updated-macro.show-more-aria-label",
        defaultMessage: "Show more recent updates"
    },
    showLess: {
        id: "recently-updated-macro.show-less",
        defaultMessage: "Show less"
    },
    filterLabel: {
        id: "recently-updated-macro.filter-label",
        defaultMessage: "Viewing:"
    },
    filterAll: {
        id: "recently-updated-macro.filter-all",
        defaultMessage: "All"
    },
    filterPages: {
        id: "recently-updated-macro.filter-pages",
        defaultMessage: "Pages"
    },
    filterBlogPosts: {
        id: "recently-updated-macro.filter-blog-posts",
        defaultMessage: "Blog Posts"
    },
    filterComments: {
        id: "recently-updated-macro.filter-comments",
        defaultMessage: "Comments"
    },
    filterAttachments: {
        id: "recently-updated-macro.filter-attachments",
        defaultMessage: "Attachments"
    },
    filterWhiteboards: {
        id: "recently-updated-macro.filter-whiteboards",
        defaultMessage: "Whiteboards"
    },
    filterDatabases: {
        id: "recently-updated-macro.filter-databases",
        defaultMessage: "Databases"
    },
    filterEmbeds: {
        id: "recently-updated-macro.filter-embeds",
        defaultMessage: "Embeds"
    },
    createdBy: {
        id: "recently-updated-macro.created-by",
        defaultMessage: "created by {author}"
    },
    updatedBy: {
        id: "recently-updated-macro.updated-by",
        defaultMessage: "updated by {author}"
    },
    createdOn: {
        id: "recently-updated-macro.created-on",
        defaultMessage: "created {date}"
    },
    updatedOn: {
        id: "recently-updated-macro.updated-on",
        defaultMessage: "updated {date}"
    },
    viewChanges: {
        id: "recently-updated-macro.view-changes",
        defaultMessage: "view changes"
    },
    permalink: {
        id: "recently-updated-macro.permalink",
        defaultMessage: "Permalink"
    },
    loadingLabel: {
        id: "recently-updated-macro.loading",
        defaultMessage: "Loading recently updated content\u2026"
    },
    errorMessage: {
        id: "recently-updated-macro.error",
        defaultMessage: "Unable to load recently updated content. Please refresh to try again."
    },
    editCta: {
        id: "recently-updated-macro.edit-cta",
        defaultMessage: "Edit this macro to add content."
    },
    contributedBy: {
        id: "recently-updated-macro.contributed-by",
        defaultMessage: "contributed by <author>{name}</author>"
    },
    commentedBy: {
        id: "recently-updated-macro.commented-by",
        defaultMessage: "commented by <author>{name}</author>"
    },
    attachedBy: {
        id: "recently-updated-macro.attached-by",
        defaultMessage: "attached by <author>{name}</author>"
    },
    contributedOn: {
        id: "recently-updated-macro.contributed-on",
        defaultMessage: "contributed {date}"
    }
});









var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $3WQHM = parcelRequire("3WQHM");


var $8mra2 = parcelRequire("8mra2");

// ---------------------------------------------------------------------------
// Helpers to map GraphQL response → UpdateItem
// ---------------------------------------------------------------------------
function $8a15680b4e7af4f7$var$resolveContentType(type, url) {
    const lower = (type ?? '').toLowerCase();
    if (lower === 'blogpost' || lower === 'blog_post') return 'blogpost';
    if (lower === 'comment') return 'comment';
    if (lower === 'attachment') return 'attachment';
    if (lower === 'whiteboard') return 'whiteboard';
    if (lower === 'database') return 'database';
    if (lower === 'embed') return 'embed';
    if (lower === 'userinfo') return 'userinfo';
    if (lower === 'folder') return 'folder';
    const urlLower = (url ?? '').toLowerCase();
    if (urlLower.includes('/whiteboard/')) return 'whiteboard';
    if (urlLower.includes('/database/')) return 'database';
    if (urlLower.includes('/embed/')) return 'embed';
    if (urlLower.includes('/folder/')) return 'folder';
    return 'page';
}
function $8a15680b4e7af4f7$var$formatTimestamp(timestamp, formatDate, timeZone) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return timestamp;
    // `timeZone` must be passed explicitly. Confluence's IntlProvider does not set a
    // timeZone, so react-intl falls back to the ambient environment timezone — UTC in
    // the SSR container, the user's local zone in the browser. For timestamps near
    // midnight that renders a different day on each side of the hydration boundary,
    // which breaks hydration and forces a client re-render that hurts vc90. Sourcing
    // the zone from session data keeps SSR and client identical because both read the
    // same serialized `__SITEINFORMATION__` payload.
    return formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: timeZone
    });
}
function $8a15680b4e7af4f7$var$nodeToUpdateItem(node, formatDate, timeZone) {
    if (!node) return null;
    const content = node.content;
    if (!content) return null;
    const status = content.status ?? '';
    if (status === 'archived' || status === 'trashed') return null;
    const id = content.id ?? '';
    const title = content.title ?? '';
    const rawUrl = node.url ?? content.links?.webui ?? '';
    const url = rawUrl && !rawUrl.startsWith('/wiki') ? `/wiki${rawUrl}` : rawUrl;
    const contentType = $8a15680b4e7af4f7$var$resolveContentType(content.type, url);
    const spaceKey = content.space?.key ?? '';
    const spaceName = content.space?.name ?? '';
    // Filter out drafts
    if (!title || url.includes('resumedraft.action')) return null;
    // Date: use lastcontributed.when if available, else fall back to search node's lastModified
    const timestamp = content.metadata?.currentuser?.lastcontributed?.when ?? node.lastModified ?? null;
    const formattedDate = $8a15680b4e7af4f7$var$formatTimestamp(timestamp, formatDate, timeZone);
    // Version number determines created vs updated label
    const version = content.version?.number ?? 2;
    // Author from version.by (accountId is on KnownUser inline fragment)
    const versionBy = content.version?.by;
    const authorAccountId = versionBy?.accountId ?? '';
    const author = {
        username: authorAccountId,
        displayName: versionBy?.displayName ?? '',
        profileUrl: authorAccountId ? `/wiki/display/~${encodeURIComponent(authorAccountId)}` : '',
        avatarUrl: versionBy?.profilePicture?.path ?? ''
    };
    return {
        id: id,
        title: title,
        url: url,
        contentType: contentType,
        version: version,
        formattedDate: formattedDate,
        author: author,
        spaceKey: spaceKey,
        spaceName: spaceName
    };
}
function $8a15680b4e7af4f7$export$653b58dbd302c26b(params, cursor = null) {
    const { formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    // Session data is rendered on the server and serialized to the client, so this
    // resolves to the same zone on both sides of hydration. See formatTimestamp.
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { author: author, labels: labels, max: max, spaces: spaces, types: types, currentSpaceKey: currentSpaceKey } = params;
    // The query variable builder resolves an explicit spaces param and translates @self
    // to this host space key. Prefer the handler context over page context so this stays
    // in parity with the SSR preload and the cache-first read below
    // hits the preloaded result instead of refetching and repainting after SSR (vc90).
    // The parity is locked by "SSR preload variable parity" tests in
    // useRecentlyUpdatedItems-test.ts — keep the two in sync.
    const hostSpaceKey = currentSpaceKey ?? pageContextSpaceKey ?? '';
    const variables = (0, $cozmU.useMemo)(()=>(0, $8mra2.buildRecentlyUpdatedQueryVariables)({
            author: author,
            labels: labels,
            max: max,
            spaces: spaces,
            types: types
        }, hostSpaceKey, cursor ?? ''), [
        author,
        labels,
        max,
        spaces,
        types,
        hostSpaceKey,
        cursor
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $3WQHM.default), {
        variables: variables,
        fetchPolicy: 'cache-first',
        __callerPackage__: "recently-updated-macro"
    });
    const items = (0, $cozmU.useMemo)(()=>{
        const nodes = data?.search?.nodes ?? [];
        const result = [];
        for (const node of nodes){
            const item = $8a15680b4e7af4f7$var$nodeToUpdateItem(node, formatDate, timeZone);
            if (item !== null) result.push(item);
        }
        return result;
    }, [
        data,
        formatDate,
        timeZone
    ]);
    const pageInfo = data?.search?.pageInfo;
    const hasNextPage = pageInfo?.hasNextPage ?? false;
    const endCursor = pageInfo?.endCursor ?? null;
    return {
        items: items,
        loading: loading,
        error: error,
        hasNextPage: hasNextPage,
        endCursor: endCursor
    };
}


function $9e825d39493c30e0$export$da5ffdb7039764e9(params) {
    if (params.theme === 'social' || params.showProfilePic) return 'social';
    if (params.theme === 'sidebar') return 'sidebar';
    return 'concise';
}
function $9e825d39493c30e0$export$189998fb52336f1(items) {
    const groups = [];
    for (const item of items){
        const last = groups[groups.length - 1];
        if (last && last.author.username === item.author.username) last.items.push(item);
        else groups.push({
            author: item.author,
            items: [
                item
            ]
        });
    }
    return groups;
}
function $9e825d39493c30e0$export$d75c1d2d50b43927(items, contentType) {
    if (!contentType) return items;
    return items.filter((item)=>item.contentType === contentType);
}


/* ContentTypeFilter.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $6wGOF = parcelRequire("6wGOF");




const $90f5fa4c07d892d5$var$styles = {
    filterContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _0rIjyk8HPE"
};
function $90f5fa4c07d892d5$export$950d91f2b2755282({ value: value, onChange: onChange, options: options, filterLabel: filterLabel }) {
    const selectedOption = options.find((o)=>o.value === value) ?? options[0];
    const handleChange = (0, $cozmU.useCallback)((option)=>{
        onChange(option?.value ?? '');
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $90f5fa4c07d892d5$var$styles.filterContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span"
    }, filterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        inputId: "recently-updated-filter",
        value: selectedOption,
        options: options,
        onChange: handleChange,
        "aria-label": filterLabel,
        isSearchable: false
    }));
}


/* UpdateItems.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $7vK9E = parcelRequire("7vK9E");









var $6NvYG = parcelRequire("6NvYG");


var $eDtFr = parcelRequire("eDtFr");


var $kkFbH = parcelRequire("kkFbH");


var $2hJf7 = parcelRequire("2hJf7");


var $hMaHH = parcelRequire("hMaHH");


var $foj7F = parcelRequire("foj7F");


var $1bzO2 = parcelRequire("1bzO2");


var $bDjVc = parcelRequire("bDjVc");


var $d4GYd = parcelRequire("d4GYd");




const $9ee2fdf8f584c862$var$iconProps = {
    label: '',
    color: 'currentColor'
};
const $9ee2fdf8f584c862$var$iconByType = {
    page: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), $9ee2fdf8f584c862$var$iconProps),
    blogpost: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), $9ee2fdf8f584c862$var$iconProps),
    comment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), $9ee2fdf8f584c862$var$iconProps),
    attachment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))), $9ee2fdf8f584c862$var$iconProps),
    whiteboard: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), $9ee2fdf8f584c862$var$iconProps),
    database: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))), $9ee2fdf8f584c862$var$iconProps),
    embed: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foj7F))), $9ee2fdf8f584c862$var$iconProps),
    userinfo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), $9ee2fdf8f584c862$var$iconProps),
    folder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), $9ee2fdf8f584c862$var$iconProps)
};
function $9ee2fdf8f584c862$export$c7b34dd0f9008ad6({ contentType: contentType }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": true
    }, $9ee2fdf8f584c862$var$iconByType[contentType] ?? $9ee2fdf8f584c862$var$iconByType.page);
}


const $d2e25b1814a11d51$var$styles = {
    listItem: "_4c065U2ADO",
    sidebarListItem: "_4c065U2ADO",
    sidebarMeta: "_2sNsIg7NXe _1LMyvKZHtx _1UtDYzKGUX _43nrzT1Y8M _0LQT5EkG2W",
    titleRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLDIqT",
    itemContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    itemMeta: "_2sNsIg7NXe _2mHwu81Y8M _1UtDYzKGUX _43nrzT1Y8M _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT",
    titleLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
function $d2e25b1814a11d51$var$ItemMeta({ item: item }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const dateText = item.formattedDate;
    const authorName = item.author.displayName;
    const profileUrl = item.author.profileUrl;
    const authorTag = (chunks)=>profileUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: profileUrl
        }, chunks) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, chunks);
    let messageDescriptor = null;
    if (authorName) {
        if (item.contentType === 'comment') messageDescriptor = (0, $50e0564811ea6833$export$defe85febe8b728c).commentedBy;
        else if (item.contentType === 'attachment') messageDescriptor = (0, $50e0564811ea6833$export$defe85febe8b728c).attachedBy;
        else messageDescriptor = (0, $50e0564811ea6833$export$defe85febe8b728c).contributedBy;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d2e25b1814a11d51$var$styles.itemMeta
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span"
    }, dateText), messageDescriptor && authorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": true
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...messageDescriptor,
        values: {
            name: authorName,
            author: authorTag
        }
    }))), item.changesUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": true
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: item.changesUrl
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).viewChanges))));
}
function $d2e25b1814a11d51$export$e242e400758d6e16({ item: item }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $d2e25b1814a11d51$var$styles.listItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d2e25b1814a11d51$var$styles.itemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d2e25b1814a11d51$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ee2fdf8f584c862$export$c7b34dd0f9008ad6), {
        contentType: item.contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: item.url,
        title: item.spaceName,
        xcss: $d2e25b1814a11d51$var$styles.titleLink
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2e25b1814a11d51$var$ItemMeta, {
        item: item
    })));
} // ---------------------------------------------------------------------------
function $d2e25b1814a11d51$export$12e3c7f9d32a480e({ item: item }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $d2e25b1814a11d51$var$styles.sidebarListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d2e25b1814a11d51$var$styles.itemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d2e25b1814a11d51$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ee2fdf8f584c862$export$c7b34dd0f9008ad6), {
        contentType: item.contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: item.url,
        title: item.spaceName,
        xcss: $d2e25b1814a11d51$var$styles.titleLink
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $d2e25b1814a11d51$var$styles.sidebarMeta
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).contributedOn, {
        date: item.formattedDate
    })))));
}


/* SocialGroup.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $arQY7 = parcelRequire("arQY7");








var $4aRua = parcelRequire("4aRua");



const $97997a1bf316117d$var$styles = {
    titleRow: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLDIqT",
    itemContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    itemMeta: "_2sNsIg7NXe _2mHwu81Y8M _1UtDYzKGUX _43nrzT1Y8M _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT",
    titleLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8",
    groupItem: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLchRC",
    groupContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    nestedList: "_1LMyvKYbGa _4FKVYEPgdg _2XghbEPgdg _2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w",
    body: "_2sNsIg7NXe _1UtDYzZpcK _43nrzT1Y8M _2l4i3rGpkd"
};
function $97997a1bf316117d$export$69483b6173afa962({ group: group }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasAuthorProfile = Boolean(group.author.profileUrl);
    const hasAuthorName = Boolean(group.author.displayName);
    const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: group.author.avatarUrl,
        name: group.author.displayName,
        size: "medium"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $97997a1bf316117d$var$styles.groupItem
    }, hasAuthorProfile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: group.author.profileUrl,
        "aria-label": group.author.displayName
    }, avatar) : avatar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $97997a1bf316117d$var$styles.groupContent
    }, hasAuthorName && (hasAuthorProfile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: group.author.profileUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, group.author.displayName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, group.author.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $97997a1bf316117d$var$styles.nestedList
    }, group.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "li",
            key: item.id,
            xcss: $97997a1bf316117d$var$styles.titleRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ee2fdf8f584c862$export$c7b34dd0f9008ad6), {
            contentType: item.contentType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97997a1bf316117d$var$styles.itemContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: item.url,
            title: item.spaceName,
            xcss: $97997a1bf316117d$var$styles.titleLink
        }, item.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97997a1bf316117d$var$styles.itemMeta
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span"
        }, item.version === 1 ? formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).createdOn, {
            date: item.formattedDate
        }) : formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).updatedOn, {
            date: item.formattedDate
        })), item.changesUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            "aria-hidden": true
        }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: item.changesUrl
        }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).viewChanges))), item.permLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            "aria-hidden": true
        }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: item.permLink
        }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).permalink)))), item.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $97997a1bf316117d$var$styles.body
        }, item.body)))))));
}


/* ShowMoreButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $lfoFx = parcelRequire("lfoFx");





var $hBYtq = parcelRequire("hBYtq");


var $6mKj3 = parcelRequire("6mKj3");

const $cdd2bed1cad888b3$var$showMoreStyles = {
    button: "_30huDKYbGa _4FKVYEPgdg _0KLXrujOvk _0wOv4Q7zJH",
    showMoreLink: "_2sNsIg20Hp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2mHwu8gVvo _1UtDYzM7Tp _41LZZBMRGa _3iDTPbQ4SZ _0hPCNLDIqT"
};
function $cdd2bed1cad888b3$export$e41c325c8b11c297({ label: label, ariaLabel: ariaLabel, onClick: onClick, loading: loading }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $cdd2bed1cad888b3$var$showMoreStyles.button,
        "aria-label": (0, $6mKj3.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? ariaLabel : undefined,
        onClick: ()=>{
            if (!loading) onClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $cdd2bed1cad888b3$var$showMoreStyles.showMoreLink
    }, label, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    })));
}


const $6e55546115fc9d68$var$styles = {
    container: "_4bt5LAIZbP _2WAcuGIZbP _4c065U5zaO _1UtDYzy7kJ _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d",
    heading: "_2sNsIgWSk4 _1UtDYzy7kJ _43nrzTPgdg _0rIjyk5zaO",
    list: "_1LMyvKC2EI _2XghbEPgdg _0LQT5ENHnM",
    sidebarList: "_1LMyvKYbGa _4FKVYEPgdg _2XghbEPgdg",
    showMoreContainer: "_3vBAKH9r67 _43nrzT5zaO _46hvQm2ADO _0vfIXINvrM _4hyvPa6wH8 _3iDTPbQ4SZ _37wbyuchRC",
    groupList: "_1LMyvKYbGa _4FKVYEPgdg _2XghbEPgdg _2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w",
    emptyState: "_2sNsIg7NXe _4c065U5zaO _1UtDYzZpcK"
};
// The backend throws a NotFoundException ("Cannot find content with selector ContentSelector")
// when the macro points at a space or content that no longer resolves for this user. Nothing is
// broken, so it renders the empty state and is tracked as a success rather than reported.
const $6e55546115fc9d68$var$NOT_FOUND_EXCEPTION_ERROR_MESSAGE = 'NotFoundException';
const $6e55546115fc9d68$var$isNotFoundExceptionError = (error)=>error.message.includes($6e55546115fc9d68$var$NOT_FOUND_EXCEPTION_ERROR_MESSAGE); // ---------------------------------------------------------------------------
function $6e55546115fc9d68$var$isExtensionHandlerProps(value) {
    return Boolean(value && typeof value.mode === 'string' && typeof value.contentId === 'string' && typeof value.extensionKey === 'string' && value.node);
}
function $6e55546115fc9d68$var$getParamRawValue(raw) {
    if (raw && typeof raw === 'object' && 'value' in raw) return raw.value;
    return raw;
}
function $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, key) {
    const explicitRaw = macroParams?.[key];
    if (explicitRaw !== undefined) return $6e55546115fc9d68$var$getParamRawValue(explicitRaw);
    return $6e55546115fc9d68$var$getParamRawValue(macroDefaultProps?.[key]);
}
function $6e55546115fc9d68$var$resolveBoolean(value) {
    if (value === undefined || value === null || value === '') return undefined;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true') return true;
        if (value.toLowerCase() === 'false') return false;
    }
    return Boolean(value);
}
function $6e55546115fc9d68$var$resolveParams(macroParams, macroDefaultProps) {
    const maxCandidate = $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'max');
    const maxParsed = Number(maxCandidate);
    return {
        theme: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'theme'),
        showProfilePic: $6e55546115fc9d68$var$resolveBoolean($6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'showProfilePic')),
        spaces: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'spaces'),
        types: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'types'),
        author: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'author'),
        labels: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'labels'),
        max: Number.isFinite(maxParsed) && maxParsed > 0 ? Math.floor(maxParsed) : undefined,
        width: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'width'),
        hideHeading: $6e55546115fc9d68$var$resolveBoolean($6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'hideHeading')),
        currentSpaceKey: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'currentSpaceKey')
    };
}
function $6e55546115fc9d68$var$resolveMaxItems(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 15;
}
function $6e55546115fc9d68$export$b7b49e8070327f21({ macroDefaultProps: macroDefaultProps, macroParams: macroParams }) {
    const resolvedParams = $6e55546115fc9d68$var$resolveParams(macroParams, macroDefaultProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e55546115fc9d68$export$b4c9dfd209519996, {
        ...resolvedParams,
        macroDefaultProps: macroDefaultProps
    });
}
function $6e55546115fc9d68$export$b4c9dfd209519996({ macroDefaultProps: macroDefaultProps, ...params }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $9e825d39493c30e0$export$da5ffdb7039764e9)(params);
    const trackingProps = $6e55546115fc9d68$var$isExtensionHandlerProps(macroDefaultProps) ? {
        contentId: macroDefaultProps.contentId,
        extensionKey: macroDefaultProps.extensionKey,
        mode: macroDefaultProps.mode,
        attributes: macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(macroDefaultProps.node),
        name: (0, $5kjCz.getExperienceName)(macroDefaultProps.mode, macroDefaultProps.node)
    } : null;
    const [cursor, setCursor] = (0, $cozmU.useState)(null);
    const { items: pageItems, loading: loading, error: error, hasNextPage: hasNextPage, endCursor: endCursor } = (0, $8a15680b4e7af4f7$export$653b58dbd302c26b)(params, cursor); // Accumulate items across pages synchronously during render (not in useEffect) so
    // that items are available on the very first render without an extra re-render cycle.
    const accumulatedItemsRef = (0, $cozmU.useRef)([]);
    const prevCursorRef = (0, $cozmU.useRef)(null);
    if (!loading) {
        if (cursor === null) // Params reset or first load — replace accumulated items with the first page
        accumulatedItemsRef.current = pageItems;
        else if (cursor !== prevCursorRef.current) // New cursor page loaded — append items as returned by the query
        accumulatedItemsRef.current = [
            ...accumulatedItemsRef.current,
            ...pageItems
        ];
        prevCursorRef.current = cursor;
    }
    const itemsForRender = accumulatedItemsRef.current;
    const max = $6e55546115fc9d68$var$resolveMaxItems(params.max);
    const [visibleCount, setVisibleCount] = (0, $cozmU.useState)(max); // When key params change, reset to a fresh first-page fetch
    (0, $cozmU.useEffect)(()=>{
        setCursor(null);
        accumulatedItemsRef.current = [];
        prevCursorRef.current = null;
        setVisibleCount(max);
    }, [
        max,
        params.spaces,
        params.types,
        params.labels,
        params.author,
        params.currentSpaceKey
    ]);
    const handleShowMore = (0, $cozmU.useCallback)(()=>{
        setVisibleCount((prev)=>prev + max); // If we're close to exhausting buffered items, fetch the next GraphQL page
        if (endCursor && itemsForRender.length <= visibleCount + max) setCursor(endCursor);
    }, [
        endCursor,
        itemsForRender.length,
        max,
        visibleCount
    ]);
    const [selectedContentType, setSelectedContentType] = (0, $cozmU.useState)('');
    const contentTypeOptions = (0, $cozmU.useMemo)(()=>[
            {
                value: '',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterAll)
            },
            {
                value: 'page',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterPages)
            },
            {
                value: 'blogpost',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterBlogPosts)
            },
            {
                value: 'comment',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterComments)
            },
            {
                value: 'attachment',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterAttachments)
            },
            {
                value: 'whiteboard',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterWhiteboards)
            },
            {
                value: 'database',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterDatabases)
            },
            {
                value: 'embed',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterEmbeds)
            }
        ], [
        formatMessage
    ]);
    const handleContentTypeChange = (0, $cozmU.useCallback)((val)=>{
        setSelectedContentType(val);
    }, []);
    const filteredItems = (0, $cozmU.useMemo)(()=>(0, $9e825d39493c30e0$export$d75c1d2d50b43927)(itemsForRender, selectedContentType), [
        itemsForRender,
        selectedContentType
    ]);
    const visibleItems = filteredItems.slice(0, visibleCount);
    const hasMore = visibleCount < filteredItems.length || hasNextPage;
    const showHeading = !params.hideHeading || visibleItems.length === 0;
    const showFilter = theme === 'social';
    if (loading && itemsForRender.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "h2",
        xcss: $6e55546115fc9d68$var$styles.heading,
        testId: "recently-updated-heading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.emptyState,
        testId: "recently-updated-loading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).loadingLabel)));
    if (error && $6e55546115fc9d68$var$isNotFoundExceptionError(error)) // Expected — fall through to the empty state below, which tracks a macro success.
    (0, $7Sm4c.markErrorAsHandled)(error);
    else if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, trackingProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        ...trackingProps,
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.emptyState,
        testId: "recently-updated-error"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).errorMessage)));
    if (!loading && visibleItems.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, trackingProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), trackingProps), showHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "h2",
        xcss: $6e55546115fc9d68$var$styles.heading,
        testId: "recently-updated-heading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.emptyState,
        testId: "recently-updated-empty"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).noUpdates)));
    let itemList;
    if (theme === 'social') itemList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $6e55546115fc9d68$var$styles.groupList,
        testId: "recently-updated-social-list"
    }, (0, $9e825d39493c30e0$export$189998fb52336f1)(visibleItems).map((group, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97997a1bf316117d$export$69483b6173afa962), {
            key: group.author.username ? `${group.author.username}-${group.items[0].id}` : `group-${index}`,
            group: group
        })));
    else if (theme === 'sidebar') itemList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $6e55546115fc9d68$var$styles.sidebarList,
        testId: "recently-updated-list"
    }, visibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2e25b1814a11d51$export$12e3c7f9d32a480e), {
            key: item.id,
            item: item
        })));
    else itemList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $6e55546115fc9d68$var$styles.list,
        testId: "recently-updated-list"
    }, visibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2e25b1814a11d51$export$e242e400758d6e16), {
            key: item.id,
            item: item
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, trackingProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), trackingProps), showHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "h2",
        xcss: $6e55546115fc9d68$var$styles.heading,
        testId: "recently-updated-heading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).heading)), showFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90f5fa4c07d892d5$export$950d91f2b2755282), {
        value: selectedContentType,
        onChange: handleContentTypeChange,
        options: contentTypeOptions,
        filterLabel: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterLabel)
    }), itemList, hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6e55546115fc9d68$var$styles.showMoreContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdd2bed1cad888b3$export$e41c325c8b11c297), {
        label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).showMore),
        ariaLabel: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).showMoreAriaLabel),
        onClick: handleShowMore,
        loading: loading
    })));
}
module.exports["RecentlyUpdatedMacroRendererHandler"] = $6e55546115fc9d68$export$b7b49e8070327f21;
module.exports["RecentlyUpdatedMacroRenderer"] = $6e55546115fc9d68$export$b4c9dfd209519996;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("3WQHM", function(module, exports) {
/**
 * @generated SignedSource<<d93dcd7c10f7020beaca89b6f3698114>>
 * @relayHash 727c301958baf0a557d685e96bfcc728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd
const $0db13d9be330dd35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContributionStatusSummary",
                        "kind": "LinkedField",
                        "name": "lastcontributed",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "when"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "number"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "727c301958baf0a557d685e96bfcc728",
            "id": "70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd",
            "metadata": {},
            "name": "RecentlyUpdatedMacroQuery",
            "operationKind": "query",
            "text": "query RecentlyUpdatedMacroQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,lastModified,content{id,type,title,status,space{key,name,id},links{webui},metadata{currentuser{lastcontributed{when}}},version{number,by{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$0db13d9be330dd35$var$node.hash = "7e6233c32402f853522988d79db44911";
var $0db13d9be330dd35$export$2e2bcd8739ae039 = $0db13d9be330dd35$var$node;
module.exports["default"] = $0db13d9be330dd35$export$2e2bcd8739ae039;

});

parcelRegister("8mra2", function(module, exports) {
const $9f74d735080597cb$export$e2092582db731ff4 = 15;
const $9f74d735080597cb$export$31a1864be1d33bad = [
    'page',
    'blogpost',
    'comment',
    'attachment',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $9f74d735080597cb$var$TYPE_ALIASES = {
    news: 'blogpost',
    blog: 'blogpost',
    blogs: 'blogpost',
    'blog-post': 'blogpost',
    blogposts: 'blogpost',
    'blog-posts': 'blogpost',
    pages: 'page',
    comments: 'comment',
    attachments: 'attachment'
};
const $9f74d735080597cb$var$SUPPORTED_TYPES = new Set($9f74d735080597cb$export$31a1864be1d33bad);
function $9f74d735080597cb$var$isContentType(type) {
    return $9f74d735080597cb$var$SUPPORTED_TYPES.has(type);
}
function $9f74d735080597cb$var$normalizeType(rawType) {
    const normalized = $9f74d735080597cb$var$TYPE_ALIASES[rawType] ?? rawType;
    return $9f74d735080597cb$var$isContentType(normalized) ? normalized : undefined;
}
function $9f74d735080597cb$var$parseCommaSeparatedValues(value) {
    if (!value) return [];
    const parts = value.split(',');
    const result = [];
    for (const part of parts){
        const trimmed = part.trim();
        if (trimmed.length > 0) result.push(trimmed);
    }
    return result;
}
const $9f74d735080597cb$var$SPACE_SCOPE_TOKENS = {
    '@personal': 'space.type = personal',
    '@global': 'space.type != personal'
};
function $9f74d735080597cb$var$resolveSpaceClause(spaces, currentSpaceKey) {
    const configuredSpaceKeys = $9f74d735080597cb$var$parseCommaSeparatedValues(spaces);
    if (configuredSpaceKeys.length === 0) return currentSpaceKey ? `space = "${currentSpaceKey}"` : undefined;
    if (configuredSpaceKeys.includes('@all') || configuredSpaceKeys.includes('*')) return undefined;
    const resolvedSpaceKeys = [];
    const spaceScopeClauses = new Set();
    let includeFavoriteSpaces = false;
    for (const spaceKey of configuredSpaceKeys){
        if (spaceKey === '@favorite' || spaceKey === '@favourite') {
            includeFavoriteSpaces = true;
            continue;
        }
        if ($9f74d735080597cb$var$SPACE_SCOPE_TOKENS[spaceKey]) {
            spaceScopeClauses.add($9f74d735080597cb$var$SPACE_SCOPE_TOKENS[spaceKey]);
            continue;
        }
        const resolvedSpaceKey = spaceKey === '@self' ? currentSpaceKey : spaceKey;
        if (resolvedSpaceKey) resolvedSpaceKeys.push(resolvedSpaceKey);
    }
    const clauses = [];
    if (resolvedSpaceKeys.length === 1) clauses.push(`space = "${resolvedSpaceKeys[0]}"`);
    else if (resolvedSpaceKeys.length > 1) clauses.push(`space in (${$9f74d735080597cb$var$formatQuotedCqlValues(resolvedSpaceKeys)})`);
    for (const spaceScopeClause of spaceScopeClauses)clauses.push(spaceScopeClause);
    if (includeFavoriteSpaces) clauses.push('space in (favouriteSpaces())');
    return clauses.length > 1 ? `(${clauses.join(' OR ')})` : clauses[0];
}
function $9f74d735080597cb$var$formatQuotedCqlValues(values) {
    return values.map((v)=>`"${v}"`).join(', ');
}
function $9f74d735080597cb$export$bbd572e80a63521b(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : $9f74d735080597cb$export$e2092582db731ff4;
}
function $9f74d735080597cb$export$6a81e704675faae5(params, spaceClause) {
    const clauses = [];
    // Content types
    const typeSet = new Set();
    if (params.types) for (const part of $9f74d735080597cb$var$parseCommaSeparatedValues(String(params.types))){
        const normalizedType = $9f74d735080597cb$var$normalizeType(part.toLowerCase());
        if (normalizedType) typeSet.add(normalizedType);
    }
    else for (const t of $9f74d735080597cb$export$31a1864be1d33bad)typeSet.add(t);
    if (typeSet.size > 0) clauses.push(`type in (${[
        ...typeSet
    ].join(', ')})`);
    // Space scope — defaults to the current space
    if (spaceClause) clauses.push(spaceClause);
    // Labels
    if (params.labels) {
        const labelList = String(params.labels).split(',').map((l)=>`"${l.trim()}"`).join(', ');
        clauses.push(`label in (${labelList})`);
    }
    // Following users / contributors (author param — comma-separated account IDs)
    if (params.author) {
        const users = String(params.author).split(',').map((u)=>`"${u.trim()}"`).join(', ');
        clauses.push(`contributor in (${users})`);
    }
    return `${clauses.join(' AND ')} order by lastmodified desc`;
}
function $9f74d735080597cb$export$ae985ad2d8a37df8(params, currentSpaceKey, after = '') {
    const maxItems = $9f74d735080597cb$export$bbd572e80a63521b(params.max);
    const spaceClause = $9f74d735080597cb$var$resolveSpaceClause(params.spaces, currentSpaceKey);
    return {
        cql: $9f74d735080597cb$export$6a81e704675faae5(params, spaceClause),
        cqlcontext: '{"contentStatuses":["draft", "current"]}',
        first: maxItems,
        after: after
    };
}
module.exports["buildRecentlyUpdatedQueryVariables"] = $9f74d735080597cb$export$ae985ad2d8a37df8;

});


//# sourceMappingURL=RecentlyUpdatedMacroRenderer.fafb0990.js.map
